import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestGroupingFormFeedback from './TestGroupingFormFeedback'
import TestGroupingFormFonts from './TestGroupingFormFont'
import TestGroupingFormStyle from './TestGroupingFormStyle'
import type { TestGroupingFormBrandType, TestGroupingBrandForms } from './testGroupingTypes'

const FORM_MAP: TestGroupingBrandForms = {
  [BrandFormEnum.STYLE]: TestGroupingFormStyle,
  [BrandFormEnum.FEEDBACK]: TestGroupingFormFeedback,
  ...(TestGroupingFormFonts as TestGroupingBrandForms),
}

const GroupingFormBrand: TestGroupingFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(GroupingFormBrand) as typeof GroupingFormBrand
